// src/pages/PainelAgendamentos/Tabela/TabelaHeaderInputs.jsx
import { useState } from "react";
import {
  Calendar,
  Clock,
  Building2,
  User,
  Cog,
  Wrench,
  List,
  ChevronDown,
  CheckCircle,
  Hammer,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function TabelaHeaderInputs({ filtro, setFiltro }) {
  const [open, setOpen] = useState(false);

  const opcoesStatus = [
    { value: "", label: "Todos" },
    { value: "Pendente", label: "Pendente" },
    { value: "Concluído", label: "Concluído" },
    { value: "Reagendado", label: "Reagendado" },
    { value: "Cancelado", label: "Cancelado" },
  ];

  // 🔹 normaliza o valor antes de salvar no filtro
  const handleInput = (field, value) => {
    const normalizado = value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
    setFiltro({ ...filtro, [field]: normalizado });
  };

  const handleSelect = (value) => {
    setFiltro({ ...filtro, status: value });
    setOpen(false);
  };

  const statusSelecionado =
    opcoesStatus.find((s) => s.value === filtro.status)?.label || "Todos";

  return (
    <>
      {/* Data */}
      <th className="w-[7%] px-2 py-4 text-center text-sm font-semibold border border-slate-400 text-white">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-1">
            <Calendar size={14} />
            <span>Data</span>
          </div>
          <input
            type="text"
            value={filtro.data}
            onChange={(e) => handleInput("data", e.target.value)}
            className="mt-2 w-full bg-transparent border-0 border-b border-white/40 text-white text-xs text-center focus:outline-none"
          />
        </div>
      </th>

      {/* Hora */}
      <th className="w-[7%] px-2 py-4 text-center text-sm font-semibold border border-slate-400 text-white">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-1">
            <Clock size={14} />
            <span>Hora</span>
          </div>
          <input
            type="text"
            value={filtro.hora}
            onChange={(e) => handleInput("hora", e.target.value)}
            className="mt-2 w-full bg-transparent border-0 border-b border-white/40 text-white text-xs text-center focus:outline-none"
          />
        </div>
      </th>

      {/* Finalizado */}
      <th className="w-[8%] px-2 py-4 text-center text-sm font-semibold border border-slate-400 text-white">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-1">
            <CheckCircle size={14} />
            <span>Finalizado</span>
          </div>
          <input
            type="text"
            value={filtro.finalizado || ""}
            onChange={(e) => handleInput("finalizado", e.target.value)}
            className="mt-2 w-full bg-transparent border-0 border-b border-white/40 text-white text-xs text-center focus:outline-none"
          />
        </div>
      </th>

      {/* Empresa */}
      <th className="w-[30%] px-2 py-4 text-center text-sm font-semibold border border-slate-400 text-white">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-1">
            <Building2 size={14} />
            <span>Empresa</span>
          </div>
          <input
            type="text"
            value={filtro.empresa}
            onChange={(e) => handleInput("empresa", e.target.value)}
            className="mt-2 w-full bg-transparent border-0 border-b border-white/40 text-white text-xs text-center focus:outline-none"
          />
        </div>
      </th>

      {/* Colaborador */}
      <th className="w-[10%] px-2 py-4 text-center text-sm font-semibold border border-slate-400 text-white">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-1">
            <User size={14} />
            <span>Colaborador</span>
          </div>
          <input
            type="text"
            value={filtro.colaborador}
            onChange={(e) => handleInput("colaborador", e.target.value)}
            className="mt-2 w-full bg-transparent border-0 border-b border-white/40 text-white text-xs text-center focus:outline-none"
          />
        </div>
      </th>

      {/* Tipo de Serviço */}
      <th className="w-[12%] px-2 py-4 text-center text-sm font-semibold border border-slate-400 text-white">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-1">
            <Cog size={14} />
            <span>Serviço</span>
          </div>
          <input
            type="text"
            value={filtro.tipo_servico}
            onChange={(e) => handleInput("tipo_servico", e.target.value)}
            className="mt-2 w-full bg-transparent border-0 border-b border-white/40 text-white text-xs text-center focus:outline-none"
          />
        </div>
      </th>

      {/* Técnico */}
      <th className="w-[9%] px-2 py-4 text-center text-sm font-semibold border border-slate-400 text-white">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-1">
            <Wrench size={14} />
            <span>Técnico</span>
          </div>
          <input
            type="text"
            value={filtro.tecnico}
            onChange={(e) => handleInput("tecnico", e.target.value)}
            className="mt-2 w-full bg-transparent border-0 border-b border-white/40 text-white text-xs text-center focus:outline-none"
          />
        </div>
      </th>

      {/* Status */}
      <th className="w-[8%] px-2 py-4 text-center text-sm font-semibold border border-slate-400 text-white relative">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-1">
            <List size={14} />
            <span>Status</span>
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="mt-2 w-full flex items-center justify-between bg-transparent border-0 border-b border-white/40 text-white text-xs px-2 py-1 focus:outline-none"
          >
            {statusSelecionado}
            <ChevronDown size={14} className="ml-1" />
          </button>

          <AnimatePresence>
            {open && (
              <motion.ul
                initial={{ opacity: 0, y: -5 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -5 }}
                transition={{ duration: 0.12 }}
                className="absolute top-[85px] w-40 bg-white shadow-md rounded-md border border-slate-300 z-50"
              >
                {opcoesStatus.map((op) => (
                  <li
                    key={op.value}
                    onClick={() => handleSelect(op.value)}
                    className={`px-4 py-2 cursor-pointer text-sm text-gray-800 hover:bg-slate-100 ${
                      filtro.status === op.value ? "font-semibold" : ""
                    }`}
                  >
                    {op.label}
                  </li>
                ))}
              </motion.ul>
            )}
          </AnimatePresence>
        </div>
      </th>

      {/* Ações */}
      <th className="w-[7%] px-2 py-4 text-center text-sm font-semibold border border-slate-400 text-white">
        <div className="flex items-center justify-center gap-1">
          <Hammer size={14} />
          <span>Ações</span>
        </div>
      </th>
    </>
  );
}
